import { render, staticRenderFns } from "./Horse.vue?vue&type=template&id=3dce4264&"
import script from "./Horse.vue?vue&type=script&lang=js&"
export * from "./Horse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports